import filter from "ramda/src/filter";
import find from "ramda/src/find";
import lte from "ramda/src/lte";
import map from "ramda/src/map";
import pipe from "ramda/src/pipe";
import sum from "ramda/src/sum";

import {
  getFixedLiterage,
  getSqMetersMultipliedByCoats,
  isConfigurable,
  isNotConfigurable,
} from "./areaFns";

import { getLiterageForSqMeterage, applyToUsageRangeKeys } from "./usageFns";

export const isConfigurableFilter = filter(isConfigurable);

export const isNotConfigurableFilter = filter(isNotConfigurable);

export const mapToFixedLiterage = map(getFixedLiterage);

/**
 * Map the area list to the total sq meterage multiplied by the coats required for the area
 */
export const sqMeterageMultipliedByCoats = map(getSqMetersMultipliedByCoats);

/**
 * Get the sum of the coating literage required for non-configurable areas that have a fixed literage set
 */
export const sumOfNonConfigurableAreaLiterages = pipe(
  isNotConfigurableFilter,
  mapToFixedLiterage,
  sum
);

/**
 * Returned fn gets the sum of the square meterage multiplied by the number of coats of coating required for all configurable areas
 */
export const sumOfConfigurableAreaSqMeterageMultipliedByCoats = pipe(
  isConfigurableFilter,
  sqMeterageMultipliedByCoats,
  sum
);

/**
 * Returned fn finds the first item in a list which is less than or equal to the sum of configurable
 * areas multiplied by the coats required. It is possible for that value to be negative if windows and doors
 * are added to a small area, so we set a minimum value of zero
 */
export const findLteSumOfConfigurableAreaSqMeterageMultipliedByCoats = pipe(
  sumOfConfigurableAreaSqMeterageMultipliedByCoats,
  pipe(lte, find)
);

/**
 * Returned fn gets the total literage required for all configurable areas by applying our find last greater than
 * function to the usage range keys, and then fetching the appropriate literage
 */
export const getLiterageRequiredForConfigurableAreaList = pipe(
  findLteSumOfConfigurableAreaSqMeterageMultipliedByCoats,
  applyToUsageRangeKeys,
  getLiterageForSqMeterage
);
